/* MCR · Frequently bought together (<mcr-fbx>): tick items, pick a size, live totals, add the set in one call.
   The optional bundle saving is display-only and mirrors a Shopify automatic discount set up by the merchant. */
(function () {
  if (customElements.get('mcr-fbx')) return;
  var doc = document;

  function money(cents, format) {
    var v = (cents / 100).toFixed(2).split('.');
    var int = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var dec = v[1] === '00' ? int : int + '.' + v[1];
    format = format || '₹{{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, int)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dec.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, dec);
  }

  customElements.define('mcr-fbx', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.fmt = this.dataset.moneyFormat;
      this.pct = parseFloat(this.dataset.percent) || 0;
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-fbx-item]'));
      this.addEventListener('change', function (e) {
        var sel = e.target.closest('[data-fbx-variant]');
        if (sel) {
          var item = sel.closest('[data-fbx-item]');
          var opt = sel.options[sel.selectedIndex];
          item.dataset.variant = sel.value;
          item.dataset.price = opt.dataset.price;
          var pr = item.querySelector('[data-fbx-price]');
          if (pr) pr.textContent = money(parseInt(opt.dataset.price, 10), self.fmt);
        }
        self.recalc();
      });
      this.querySelector('[data-fbx-add]').addEventListener('click', function () { self.add(); });
      // keep the current product in sync with the main variant picker
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
          var v = payload && payload.data && payload.data.variant;
          var cur = self.querySelector('[data-current]');
          if (!v || !cur) return;
          cur.dataset.variant = v.id;
          cur.dataset.price = v.price;
          var p = cur.querySelector('.mcr-fbx__price');
          if (p) p.textContent = money(v.price, self.fmt);
          self.recalc();
        });
      }
      this.recalc();
    }
    selected() {
      return this.items.filter(function (i) { return i.querySelector('[data-fbx-check]').checked; });
    }
    recalc() {
      var sel = this.selected();
      this.items.forEach(function (i) { i.classList.toggle('is-on', i.querySelector('[data-fbx-check]').checked); });
      var sub = sel.reduce(function (s, i) { return s + (parseInt(i.dataset.price, 10) || 0); }, 0);
      var save = sel.length > 1 ? Math.round(sub * this.pct / 100) : 0;
      this.querySelector('[data-fbx-count]').textContent = sel.length;
      this.querySelector('[data-fbx-subtotal]').textContent = money(sub, this.fmt);
      var sv = this.querySelector('[data-fbx-saving]');
      if (sv) sv.textContent = save ? '−' + money(save, this.fmt) : '—';
      this.querySelector('[data-fbx-total]').textContent = money(sub - save, this.fmt);
      var btn = this.querySelector('[data-fbx-add]');
      btn.disabled = sel.length === 0;
      this.querySelector('[data-fbx-add-label]').textContent = (this.dataset.addLabel || '').replace('[count]', sel.length);
    }
    add() {
      var self = this;
      var err = this.querySelector('[data-fbx-error]');
      err.hidden = true;
      var items = this.selected().map(function (i) { return { id: parseInt(i.dataset.variant, 10), quantity: 1 }; });
      if (!items.length) return;
      var drawer = doc.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      var btn = this.querySelector('[data-fbx-add]');
      btn.disabled = true;
      btn.classList.add('is-loading');
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || res.message);
          if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(res); }
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (e) { err.textContent = e.message || 'Error'; err.hidden = false; })
        .finally(function () { btn.classList.remove('is-loading'); self.recalc(); });
    }
  });
})();
